import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { submitTRA } from '../services/reservation-guests/api'
import { useAsyncJobStore } from '../stores/async-jobs'
import { taskTypeEnum, buildOptimisticJob } from '../services/async-jobs/models'
import { reservationQueries } from '../services/reservations/queries'

export function useSubmitTraForGuest() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const restoreActive = useAsyncJobStore((s) => s.actions.restoreActive)

  return useMutation({
    mutationFn: submitTRA,
    onSuccess: (data, variables) => {
      // Drop the job into the active store immediately so the guest's TRA
      // spinner is on the instant dispatch returns — the ws/poll supersedes
      // this same-id entry on completion.
      restoreActive(
        buildOptimisticJob({
          id: data.jobId,
          taskType: taskTypeEnum.TRA_SUBMISSION,
          entityId: variables.reservationGuestId,
          entityType: 'ReservationGuest',
          label: t('asyncJobs.traSubmission'),
        }),
      )
      queryClient.invalidateQueries({ queryKey: reservationQueries.all() })
    },
  })
}
